export default __webpack_public_path__ + "static/media/google-play-badge-cropped.be447c8b.png";